__turbopack_context__.v({
  "button-wrapper": "AliasGenerationButton-module-scss-module__1FUirq__button-wrapper",
  "menu-item-wrapper": "AliasGenerationButton-module-scss-module__1FUirq__menu-item-wrapper",
  "popup": "AliasGenerationButton-module-scss-module__1FUirq__popup",
});
